import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Industries from "@/pages/Industries";

export const Route = createFileRoute("/zh-cn/industries/")({
  head: () => buildRouteHead("/zh-cn/industries"),
  component: Industries,
});

